import { TooltipProvider } from "@app/ui";
import { ClerkProvider, SignIn, SignedIn, SignedOut } from "@clerk/clerk-react";
import type { ReactNode } from "react";
import { AppCssBaseLine } from "./css-baseline/app-css-baseline";
import { ErrorBoundary } from "./error/error-boundary";
import { SnackbarList } from "./snackbar/snackbar-list";
import { AppThemeProvider } from "./theme/app-theme-provider";
import { HasOrganization } from "./user/has-organization";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
	throw new Error("Missing Clerk Publishable Key");
}

export const App = ({ children }: { children: ReactNode }) => {
	return (
		<ErrorBoundary>
			<ClerkProvider
				publishableKey={PUBLISHABLE_KEY}
				afterSignOutUrl="/"
				telemetry={false}
			>
				<AppThemeProvider>
					<TooltipProvider>
						<AppCssBaseLine />
						<SignedOut>
							<div
								style={{
									display: "flex",
									justifyContent: "center",
									paddingTop: "80px",
								}}
							>
								<SignIn forceRedirectUrl={window.location.pathname} />
							</div>
						</SignedOut>
						<SignedIn>
							<HasOrganization>
								<ErrorBoundary>{children}</ErrorBoundary>
							</HasOrganization>
						</SignedIn>
						<SnackbarList />
					</TooltipProvider>
				</AppThemeProvider>
			</ClerkProvider>
		</ErrorBoundary>
	);
};
